import {Component, Input} from '@angular/core';

@Component({
    selector: 'mm-learning-progress-visualization',
    templateUrl: './learning-progress-visualization.component.html',
    styleUrls: ['./learning-progress-visualization.component.scss'],
    standalone: false
})
export class LearningProgressVisualizationComponent {
    @Input() studyProgress: number | undefined;
    @Input() learningGoal: number | undefined;
    @Input() studyProgressScaleName: string | undefined;
    @Input({required: true}) learningPackageIsAvailable!: boolean;
    @Input() manualActivation: boolean | undefined;
    @Input() reachableLearningProgress: number | undefined;

    public getStudyProgressPointPosition(studyProgress: number): string {
        const shift = Math.round((studyProgress * 22) / 100);
        return `calc(${studyProgress}% - ${shift}px)`;
    }
}
